import type { WebsiteBlock } from '../../types'
import { useBranding } from '../../contexts/BrandingContext'
import { useI18n } from '../../i18n'

interface AboutProps {
  title: string
  titleEn?: string
  description: string
  descriptionEn?: string
  imageUrl?: string
  stats?: Array<{ value: string; label: string; labelEn?: string }>
}

export default function AboutBlock({ block }: { block: WebsiteBlock }) {
  const { branding } = useBranding()
  const { lang } = useI18n()
  const p = block.props as AboutProps

  const title = lang === 'en' && p.titleEn ? p.titleEn : p.title
  const hasContent = title?.trim() || p.description?.trim() || p.imageUrl
  if (!hasContent) return null

  return (
    <section className="py-20 px-6 bg-gray-50/50">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            {title?.trim() && (
              <h2 className="text-2xl md:text-3xl font-bold mb-6 tracking-tight" style={{ color: branding.secondaryColor }}>
                {title}
              </h2>
            )}
            <p className="text-gray-500 leading-relaxed text-sm whitespace-pre-wrap">
              {lang === 'en' && p.descriptionEn ? p.descriptionEn : p.description}
            </p>
          </div>
          {p.imageUrl && (
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img src={p.imageUrl} alt="" className="w-full h-64 md:h-80 object-cover" />
            </div>
          )}
        </div>
        {p.stats && p.stats.length > 0 && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">
            {p.stats.map((s, i) => (
              <div key={i} className="text-center p-4 rounded-2xl bg-white border border-black/[0.04]">
                <div className="text-2xl font-bold mb-1" style={{ color: branding.primaryColor }}>{s.value}</div>
                <div className="text-xs text-gray-400">{lang === 'en' && s.labelEn ? s.labelEn : s.label}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  )
}
